import { useDispatch, useSelector } from 'react-redux'
import styles from './VNNoItemsFound.module.scss'
import { CircularProgress } from '@material-ui/core'
import FavoriteIcon from './VNFavoriteIcon'
import { ReactComponent as InputSearchIcon } from '../../assets/input-search-icon.svg'
import { APPLICATION_STRINGS } from '../../strings'
import { setSelectedCategory } from '../ActionCreators'
import { ALL_ID, FAVORITES_ID, getCategorySearch, getSelectedCategory } from '../Selectors'
import { getIsMenuItemsLoading } from '../../selectors/categories'
import { getBarcodeScanningSettings } from '../../selectors/config'
import { ReactComponent as ScanItems } from '../../assets/icons/scan-items.svg'

/**
 * Message displayed when no items are found in the current category or favorites
 *
 * @returns {JSX.Element}
 */
const VNNoItemsFound = () => {
  const dispatch = useDispatch()

  const searchTerm = useSelector(getCategorySearch)
  const currentCategory = useSelector(getSelectedCategory)
  const isLoading = useSelector(getIsMenuItemsLoading)
  const barcodeScanningSettings = useSelector(getBarcodeScanningSettings)

  if (isLoading) {
    return (
      <div className={styles.instructions}>
        <CircularProgress size="1em" color="inherit" />
        <div className={styles.text}>{APPLICATION_STRINGS.LOADING}</div>
      </div>
    )
  }

  // no items are found in favorites category, display instructions
  if (currentCategory === FAVORITES_ID && !searchTerm.length) {
    return (
      <div className={styles.instructions}>
        <FavoriteIcon className={styles.icon} />
        <div className={styles.text}>{APPLICATION_STRINGS.FAVORITES_INSTRUCTIONS}</div>
      </div>
    )
  }

  // no items found in the current category
  if (searchTerm.length) {
    return (
      <div className={styles.instructions}>
        <InputSearchIcon className={styles.icon} />
        <div className={styles.text}>
          {APPLICATION_STRINGS.NO_ITEM_FOUND}
          {currentCategory !== ALL_ID && (
            <span className={styles.link} onClick={() => dispatch(setSelectedCategory(ALL_ID))}>
              <br />
              {APPLICATION_STRINGS.NO_ITEM_INSTRUCTIONS}
            </span>
          )}
        </div>
      </div>
    )
  }

  if (barcodeScanningSettings.barcodeScanningEnabled) {
    return (
      <div className={styles.instructions}>
        <ScanItems />
        <div className={styles.text}>{APPLICATION_STRINGS.SCAN_ITEMS_TO_CART}</div>
      </div>
    )
  }

  return null
}

export default VNNoItemsFound
